import dayjs from 'dayjs';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPut } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMPLOYEEID_PATH_KEY } from '@/swagger/constants/anagraphics-keys';
import {
  API_PUT_EMPLOYER_BY_ID,
  DD_MM_YYYY_WITH_SLASH_REGEX,
  KEY_PUT_EMPLOYER_BY_ID,
  YYYY_MM_DD_WITH_DASH_REGEX,
} from '../constants';
import { MOCK_RESPONSE_PUT_EMPLOYER_BY_ID } from '../mocks';

type GenericPutEmployerById = GenericPut<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMPLOYEEID_PATH_KEY
>;

type RequestPutEmployerById = GenericPutEmployerById['request']['body'] &
  GenericPutEmployerById['request']['path'];

export type CallParamsPutEmployerById = Omit<RequestPutEmployerById, 'organizationId'> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponsePutEmployerById = GenericPutEmployerById['response']['body'];

type CallErrorPutEmployerById = GenericApiError;

type CallSelectorsPutEmployerById = unknown;

export const putEmployerByIdCall = createGeneralCall<
  CallParamsPutEmployerById,
  CallResponsePutEmployerById,
  CallErrorPutEmployerById,
  CallSelectorsPutEmployerById
>({
  id: KEY_PUT_EMPLOYER_BY_ID,
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_PUT_EMPLOYER_BY_ID(org as unknown as string, payload.employeeId);
    },
  paramsSelector:
    ({ payload }) =>
    () => {
      let birthDate;
      if (payload?.birthDate) {
        if (
          DD_MM_YYYY_WITH_SLASH_REGEX.test(payload.birthDate) &&
          dayjs(payload.birthDate, 'DD/MM/YYYY', true).isValid() &&
          dayjs(payload.birthDate, 'DD/MM/YYYY', true).isAfter(dayjs().subtract(100, 'year'))
        ) {
          birthDate = dayjs(payload.birthDate, 'DD/MM/YYYY', true).format('YYYY-MM-DD');
        } else if (YYYY_MM_DD_WITH_DASH_REGEX.test(payload?.birthDate || '')) {
          birthDate = payload?.birthDate; // already in correct format date from BE
        } else if (payload?.birthDate) {
          birthDate = '';
        }
      }
      return {
        ...payload,
        birthDate,
        employeeId: undefined,
      };
    },
  method: 'put',
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_PUT_EMPLOYER_BY_ID : undefined,
});
